// A chat user id is the sender's Ably clientId - "hcp-23806-397855", "speaker-23806-6766",
// "moderator-23806-274" - so its leading segment is the sender type.
const LABEL_BY_TYPE = {
  moderator: "Moderator",
  speaker: "Speaker Doctor",
  hcp: "Doctor",
};

function chatUserType(userId) {
  return String(userId || "").split("-")[0];
}

export function chatDisplayName(userId) {
  return LABEL_BY_TYPE[chatUserType(userId)] || LABEL_BY_TYPE.hcp;
}

export function isAdminChatUserId(userId) {
  return chatUserType(userId) === "moderator";
}
